import { CopyToClipboard, StackedTextCell } from '@retail/components';
import { GridColDef } from '@mui/x-data-grid-premium';
import { useProductsTFunction } from '@retail/products/i18n';

interface BaseItem {
  mgItemNumber: number;
  finfoNumber?: number;
  nobbNumber?: number;
}

export type ExternalItemSource = 'FINFO' | 'NOBB';

interface Props<TItem extends BaseItem> {
  externalItemSource: ExternalItemSource;
  columnProps?: Partial<GridColDef<TItem>>;
}

export const useMgItemAndExternalNumberColumn = <TItem extends BaseItem>({
  columnProps = {},
  externalItemSource,
}: Props<TItem>) => {
  const t = useProductsTFunction();
  const column: GridColDef<TItem> = {
    ...columnProps,
    field: 'mgItemAndExternalNumber',
    width: 130,
    renderHeader: () => {
      const { top, bottom } =
        externalItemSource === 'NOBB'
          ? { top: t('products.nobb.number'), bottom: t('products.mgItem.number.short') }
          : {
              top: t('products.mgItem.number.short'),
              bottom: t('products.mgItem.supplierItem.finfoNumber.short'),
            };
      return <StackedTextCell topLine={top} bottomLine={bottom} gap="small" />;
    },

    renderCell: ({ row }) => {
      const { top, bottom } =
        externalItemSource === 'NOBB'
          ? { top: row.nobbNumber, bottom: row.mgItemNumber }
          : { top: row.mgItemNumber, bottom: row.finfoNumber };
      return (
        <StackedTextCell
          topLine={
            top ? (
              <CopyToClipboard value={top} hasIconButtonPadding={false}>
                {top}
              </CopyToClipboard>
            ) : (
              '-'
            )
          }
          bottomLine={bottom}
        />
      );
    },
    valueGetter: (_, row) => row.mgItemNumber,
  };

  return column;
};
